module.exports = __webpack_public_path__ + "static/img/90011B_1_C_20240319_LC.9a5f185.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/90011B_1_C_20240319_LC.png
// module id = m4Fs
// module chunks = 0